/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var fieldDefaults = function () {
    return {
        width: 200
    };
};
export function addFieldDefaults(field) {
    return __assign(__assign({}, fieldDefaults()), field);
}
export function initialiseFieldMeta(pageSize, filterVisibility) {
    if (filterVisibility === undefined)
        filterVisibility = true;
    if (pageSize === undefined)
        pageSize = 50;
    return {
        data: {},
        order: {
            active: [],
            inactive: []
        },
        filterVisibility: filterVisibility,
        pageSize: pageSize
    };
}
